import { useState } from "react";

export default function FAQItem({ item, open, onToggle }) {
  const [localOpen, setLocalOpen] = useState(false);
  const isOpen = onToggle ? open : localOpen;
  const toggle = onToggle || (() => setLocalOpen(o => !o));

  return (
    <div className="faq-item">
      <button className="faq-q" onClick={toggle}>
        {item.q}
        <span className={`faq-icon${isOpen ? " open" : ""}`}>+</span>
      </button>
      <div className="faq-ans" style={{ maxHeight: isOpen ? "300px" : "0" }}>
        <p>{item.a}</p>
      </div>
    </div>
  );
}